module.exports = __webpack_public_path__ + "img/header-admin.7d07e5bd.png";